import React from "react";
import SearchFormClients from "components/Clientes/SearchFormClients";
import TableClients from "components/Clientes/TableClients";
import Grid from "@material-ui/core/Grid";
import AssignLot from "views/Lote/AssignLot";
import DetailClients from "components/Clientes/DetailClients";
import DetailLot from "components/Lotes/DetailLot";
import FormContract from "components/Contract/FormContract";
export default function getStepsContract({
  step,
  selectedRow,
  column,
  clientes,
  onRowClick,
  handleSearchClient,
  getLots,
  idLot,
  lot,
  onChangeLot,
  getBlocks,
  blocks,
  idBlock,
  onChangeBlock,
  developments,
  getDevelopments,
  infolot,
  direccion,
  generatePdf,
  paymentMade,
  handleGenerateContract,
  modalNuevoCliente,
  setModalNuevoCliente
}) {
  const inputcosto = infolot.COSTO ? Number(infolot.COSTO) : 0;
 /* const inputcosto = infolotes.reduce(
    (acc, curr) => acc + parseFloat(curr.COSTO),
    0
  );*/
  switch (step) {
    case 0:
      return (
        <div>
          <SearchFormClients handleSearchClient={handleSearchClient} />
          <div style={{ marginTop: 16 }}>
            <TableClients
              column={column}
              data={clientes}
              onRowClick={onRowClick}
              selectedRow={selectedRow}
            />
          </div>
        </div>
      );
    case 1:
      return (
        <div>
          <AssignLot
            getLots={getLots}
            idLot={idLot}
            lot={lot}
            onChangeLot={onChangeLot}
            getBlocks={getBlocks}
            blocks={blocks}
            idBlock={idBlock}
            onChangeBlock={onChangeBlock}
            developments={developments}
            getDevelopments={getDevelopments}
          />
        </div>
      );
    case 2:
      return (
        <div>
          <Grid container spacing={6}>
            <Grid item xs={6} sm={4} md={6}>
              <DetailClients Cliente={selectedRow} />
            </Grid>
            <Grid item xs={6} sm={4} md={6}>
              <DetailLot LoteInfo={infolot} />
            </Grid>
          </Grid>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <FormContract
                inputcosto={inputcosto}
                infoclientes={selectedRow}
                infolotes={infolot}
                infodireccioncliente={direccion}
                generatePdf={generatePdf}
                paymentMade={paymentMade}
                handlePayment={handleGenerateContract}
              />
            </Grid>
          </Grid>
        </div>
      );
    default:
      return "Unknown step";
  }
}
